import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setNotices: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setNoticeDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
